<script setup lang='ts'>
import type { DistributionGroupWithID } from '#design-tokenomics/types'
import type { ReferenceProject } from '@forgd/contract/types'
import { Button } from '@forgd/ui-kit/button'
import { Sheet, SheetBody, SheetContent, SheetTitle } from '@forgd/ui-kit/sheet'
import { ArrowsRightLeftIcon } from '@heroicons/vue/24/outline'
import DtProjectAllocationPanel from './DtProjectAllocationPanel.vue'
import DtSelectProjectPanel from './DtSelectProjectPanel.vue'

const emit = defineEmits(['select'])
const isOpen = ref(false)

const component = shallowRef<Component>(DtSelectProjectPanel)
const currentProject = ref<ReferenceProject>()

function openPanel() {
  isOpen.value = true
}

function closePanel() {
  isOpen.value = false
  component.value = DtSelectProjectPanel
  currentProject.value = undefined
}

function toggleProjectDetails(project: ReferenceProject) {
  currentProject.value = project
  component.value = DtProjectAllocationPanel
}

function selectTemplate(allocations: DistributionGroupWithID[]) {
  emit('select', allocations)
  closePanel()
}

function back() {
  component.value = DtSelectProjectPanel
}
</script>

<template>
  <Button
    size="sm"
    variant="outline"
    class="w-38.75"
    @click="openPanel"
  >
    View References
    <ArrowsRightLeftIcon aria-hidden="true" />
  </Button>
  <Sheet :open="isOpen" :modal="false" @update:open="(open) => !open && closePanel()">
    <SheetContent
      side="right"
      size="sm"
      data-ui="Sheet"
    >
      <SheetTitle class="sr-only">
        View References
      </SheetTitle>
      <SheetBody class="p-0">
        <component
          :is="component"
          :project="currentProject"
          class="h-full min-h-0"
          @save="selectTemplate"
          @close="closePanel"
          @select="toggleProjectDetails"
          @back="back"
        />
      </SheetBody>
    </SheetContent>
  </Sheet>
</template>
